/* tslint:disable */

/**
 * Client Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Response indicating current user's membership status with a client
 * @export
 * @interface GetIsMyClientResponse
 */
export interface GetIsMyClientResponse {
	/**
	 * True if the current user is associated with this client either directly as a service contact or as a member of an assigned service team
	 * @type {boolean}
	 * @memberof GetIsMyClientResponse
	 */
	isTeamMember: boolean;
}

/**
 * Check if a given object implements the GetIsMyClientResponse interface.
 */
export function instanceOfGetIsMyClientResponse(value: object): boolean {
	let isInstance = true;
	isInstance = isInstance && 'isTeamMember' in value;

	return isInstance;
}

export function GetIsMyClientResponseFromJSON(json: any): GetIsMyClientResponse {
	return GetIsMyClientResponseFromJSONTyped(json, false);
}

export function GetIsMyClientResponseFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): GetIsMyClientResponse {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		isTeamMember: json['isTeamMember'],
	};
}

export function GetIsMyClientResponseToJSON(value?: GetIsMyClientResponse | null): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		isTeamMember: value.isTeamMember,
	};
}
